import { render, staticRenderFns } from "./PanelAdmin.vue?vue&type=template&id=ed03e980&scoped=true&"
import script from "./PanelAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PanelAdmin.vue?vue&type=style&index=0&id=ed03e980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed03e980",
  null
  
)

export default component.exports